import React from 'react'
import { Typography } from 'antd'

import { LogoCard, LogosContainer, Wrapper, Header, LogoText, TitleSection } from './styles'

const ValueProposition: React.FC = () => {
  const { Title } = Typography

  const logos = Array.from({ length: 4 }, (_, idx) => `/images/home2/image${idx}.png`)
  const labels = [
    'Todo en un solo lugar',
    'Cotización rápida',
    'Puesto en obra',
    'Compra a crédito',
  ]

  return (
    <Wrapper>
      <Header>
        <TitleSection>Nuestra propuesta de Valor</TitleSection>
        <Title level={2} style={{ margin: 0, fontFamily: 'Sora' }}>
          Así se construye <strong style={{ fontWeight: 'bold' }}>más fácil</strong>
        </Title>
      </Header>

      <LogosContainer style={{ paddingBottom: 50, height: 450 }}>
        {logos.map((src, idx) => (
          <LogoCard key={idx}>
            <div>
              <img src={src} alt={`img-${idx}`} />
            </div>
            <LogoText>{labels[idx]}</LogoText>
          </LogoCard>
        ))}
      </LogosContainer>
    </Wrapper>
  )
}

export default ValueProposition
